import { combineReducers } from 'redux'

import idSearch from './idSearch'
import publicationDeadlines from './publicationDeadline'
import publicationFilters from './publicationFilters'

export default combineReducers({
  idSearch,
  publicationDeadlines,
  publicationFilters,
})
